import React from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    useMultiStyleConfig,
    Button,
    Link as ChakraLink,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {RightIcon} from '../icons'
import {useGetCategoriesData} from '../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink} from '../../utils/contentstack-utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const DrawerCategoryItem = ({primaryCategory = {}}) => {
    const categoryData = useGetCategoriesData()
    const styles = useMultiStyleConfig('BraunMenu', {})
    const {locale} = useMultiSite()
    const {url, label, isAbsolute} = getGlobalLink({
        link: primaryCategory?.first_level_category,
        categoriesData: categoryData,
        locale: locale?.alias,
    })
    let title = label
    if (!title || title === '') {
        title = primaryCategory?.title
    }
    const drawerItem = styles?.drawerItem || {}
    return (
        <Flex {...drawerItem?.itemContainer}>
            <Flex {...drawerItem?.innerContainer}>
                {isAbsolute ? (
                    <ChakraLink
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        textDecoration="none"
                        _hover={{textDecoration: 'none'}}
                        {...drawerItem.itemText}
                    >
                        {title}
                    </ChakraLink>
                ) : (
                    <Button as="a" {...drawerItem.itemText}>
                        {title}
                    </Button>
                )}
                <RightIcon {...drawerItem?.itemIcon} />
            </Flex>
        </Flex>
    )
}

DrawerCategoryItem.propTypes = {
    primaryCategory: PropTypes.object,
}

export default DrawerCategoryItem
